import {
  setNotificationDrawerVisibleStatus,
  saveNotificationPreferences,
  fetchNotificationPreferences,
  resetNotificationPreferences,
} from '../routines/notificationRoutines';

const defaultNotificationPreferences = {
  isSendEmailNotifications: false,
  changesToPrimaryOwner: false,
  changesToSecondaryOwners: false,
  otherUserTypeAttributeChanges: false,
  emailsSyncedToTheEntity: false,
  newTasksAssignedToYou: false,
  assignmentChangesToYourTasks: false,
  dueDateOfYourTasks: false,
  completionOfYourTasks: false,
  dueDateOfTasksYouWatch: false,
  assignmentChangesToTasksYouWatch: false,
  completionOfTasksYouWatch: false,
  newPlaybooksAssignedToYou: false,
  dueDateOfYourPlaybooks: false,
  newTicketTrigger: false,
  ticketAssignedToYou: false,
  newMessageTrigger: false,
};

const initialState = {
  isNotificationDrawerVisible: false,
  notificationPreferences: { ...defaultNotificationPreferences },
  isNotificationPreferencesLoading: false,
};

const notificationConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case setNotificationDrawerVisibleStatus.TRIGGER:
      return {
        ...state,
        isNotificationDrawerVisible: action.payload.isVisible,
      };
    case fetchNotificationPreferences.TRIGGER:
    case saveNotificationPreferences.TRIGGER:
      return {
        ...state,
        isNotificationPreferencesLoading: true,
      };
    case saveNotificationPreferences.SUCCESS:
      return {
        ...state,
        notificationPreferences: {
          ...action.payload.notificationPreferences,
        },
        isNotificationPreferencesLoading: false,
        isNotificationDrawerVisible: false,
      };
    case fetchNotificationPreferences.SUCCESS:
      return {
        ...state,
        notificationPreferences: action.payload.notificationPreferences,
        isNotificationPreferencesLoading: false,
      };
    case fetchNotificationPreferences.FAILURE:
    case saveNotificationPreferences.FAILURE:
      return {
        ...state,
        isNotificationPreferencesLoading: false,
      };
    case resetNotificationPreferences.TRIGGER:
      return {
        ...state,
        notificationPreferences: { ...defaultNotificationPreferences },
      };
    default:
      return state;
  }
};

export default notificationConfigurationReducer;
